import { ENV } from "./env";

export const DEFAULT_MAP_CENTER: [number, number] = [36.2476387, 23.56347275];

export const DEFAULT_MAP_OPTIONS = {
  style: ENV.mapStyleUrl,
  center: DEFAULT_MAP_CENTER,
  zoom: 4,
  attributionControl: true
} as const;

export const MAP_LAYER_IDS = {
  importedFill: "imported-geojson-fill",
  importedLine: "imported-geojson-line",
  importedPoint: "imported-geojson-point",
  importedPointIcon: "imported-geojson-point-icon",
  importedPointLabel: "imported-geojson-point-label",
  imageOverlay: "image-overlay-layer"
} as const;
